import React from 'react';
import { func, object } from 'prop-types';
import { CgAttachment } from 'react-icons/cg';

import '../styles/Attachment.css';

function Attachment({ attachment }) {
    return (
        <div
            className={'attachment'}
        >
            <a
                href={attachment.url}
                target={'_blank'}
                rel={'noreferrer noopener'}
                download={attachment.originalFilename}
            >
                <CgAttachment/> {attachment.originalFilename}
            </a>
        </div>
    );
}

Attachment.propTypes = {
    attachment: object,
    modalToggleHandler: func,
};

export default Attachment;